import {h} from 'preact';

export default function FilterAssociatedUsersInput({handleFilterChange, handleFilterClick, handleFilterFormSubmission, searchQuery}) {
	return (
		<form role="search" onSubmit={handleFilterFormSubmission} class="c-card__interior-left u-margin-top-default">
			<div class="eds-c-form__field">
				<label for="filter-associated-users" class="eds-c-label">Find users by name or email</label>
				<input id="filter-associated-users" type="text" class="eds-c-form__input" onInput={handleFilterChange} value={searchQuery} />
			</div>
			<button type="button" class="c-button c-button--small u-margin-left-none"
					data-track="click_associated_users"
					data-track-category="Other access methods"
					data-track-label="Filter"
					data-track-action="Button click"
					data-track-context="Associated users"
					onClick={handleFilterClick}>Search</button>
		</form>
	);
}
